import { useState } from 'react';
import { AppCard, AppObject } from '../AppCard';
import { EntObject } from '../../pages/MyHub';

interface AppCardsGridProps {
  apps: Array<AppObject> | undefined;
  entitlements: EntObject | undefined;
  sso: boolean;
  tenantId: string;
}

export const AppCardsGrid = ({
  apps,
  sso,
  tenantId,
  entitlements,
}: AppCardsGridProps) => {
  const [exception, setException] = useState<string>('');

  if (!apps || !sso) {
    return (
      <>
        <AppCard onError={setException} />
        <AppCard onError={setException} />
        <AppCard onError={setException} />
      </>
    );
  } else {
    return (
      <>
        {apps.length <= 0 ? (
          <h2>No apps available</h2>
        ) : (
          apps.map((app, index) => {
            const isOwner =
              entitlements?.apps.find((value) => value === app.id) === undefined
                ? false
                : true;

            return (
              <AppCard
                index={index}
                tenantId={tenantId}
                key={app.id}
                data={app}
                onError={setException}
                isOwner={isOwner}
              />
            );
          })
        )}
      </>
    );
  }
};
